import { render, staticRenderFns } from "./updont.vue?vue&type=template&id=3875eae1&scoped=true&"
import script from "./updont.vue?vue&type=script&lang=js&"
export * from "./updont.vue?vue&type=script&lang=js&"
import style0 from "./updont.vue?vue&type=style&index=0&id=3875eae1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875eae1",
  null
  
)

export default component.exports